// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9d22b7f","732":"96f259d3","977":"cfed56e3"}[chunkId] + ".chunk.js";
};